import {
  getBasePath
} from "./chunk.B2DPRLWS.js";

// src/components/icon/library.default.ts
var library = {
  name: "default",
  resolver: (name) => `${getBasePath()}/assets/icons/${name}.svg`
};
var library_default_default = library;

export {
  library_default_default
};
